/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ModelSettingsCredential { 
    /**
     * Provider this credential authenticates.
     */
    provider: string;
    /**
     * Who the key belongs to. Always \"customer\": a key the program entered for byok mode, billed by the provider to the customer. Dedicated mode runs on Convercus\'s models and stores no key, so no other owner is ever returned.
     */
    owner: ModelSettingsCredential.OwnerEnum;
    /**
     * Last 4 characters of the stored key — display only, the key itself is write-only.
     */
    hint?: string;
    /**
     * \"verified\" when the key passed the live provider check on save.
     */
    status?: ModelSettingsCredential.StatusEnum;
    /**
     * The custom endpoint this provider is called at. Absent = the provider default. Stored in the clear and shown in the form — only keys are secret (D7).
     */
    baseUrl?: string;
}
export namespace ModelSettingsCredential {
    export type OwnerEnum = 'customer';
    export const OwnerEnum = {
        Customer: 'customer' as OwnerEnum
    };
    export type StatusEnum = 'verified' | 'unverified';
    export const StatusEnum = {
        Verified: 'verified' as StatusEnum,
        Unverified: 'unverified' as StatusEnum
    };
}


